import { useEffect, useState } from 'react';
import useScript from 'react-script-hook';

function useOEmbed(props) {
  const { url, loadScript, onLoad, onError } = props;
  const [script, setScript] = useState(null);
  const [data, setData] = useState(null);
  useScript({
    src: loadScript ? script : null,
    async: true,
    checkForExisting: true,
  });
  useEffect(
    () => {
      if (url && window.fetch) {
        fetch(url, {})
          .then(response => {
            response.json().then(_data => {
              if (loadScript) {
                const tempElement = document.createElement('div');
                tempElement.innerHTML = _data.html;
                const scriptTag = tempElement.getElementsByTagName('script')[0];
                if (scriptTag && scriptTag.src) {
                  setScript(
                    scriptTag.src.startsWith('app://')
                      ? scriptTag.src.replace('app://', 'https://')
                      : scriptTag.src,
                  );
                }
              }
              setData(_data);
              if (typeof onLoad === 'function') {
                setTimeout(() => onLoad(_data), 0);
              }
            });
          })
          .catch(error => {
            console.error('Failed to call oembed endpoint', url, error);
            if (typeof onError === 'function') {
              onError(error);
            }
          });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [url],
  );
  return data || {};
}

export default useOEmbed;
